import { symptomTypes, commonConstant } from "../../../server/triage/constants";
import {
    generateJsonWebToken,
    checkAndGetSessionStorageValue,
    translateContent,
    getAndSetTranslateVal,
    checkAndChangeContent,
} from "../../../features/utils";
export async function submitTriageLocation({ location, state, actions }) {
    let locationMeta;

    if (location) {
        const { name, parts, lat, lng } = location;
        var locationName = name;
        var translateArray = [
            {
                text: name,
            },
            {
                text: parts.route,
            },
            {
                text: parts.sublocality_level_1,
            },
            {
                text: parts.sublocality_level_2,
            },
            {
                text: parts.sublocality_level_3,
            },
            {
                text: parts.administrative_area_level_1,
            },
            {
                text: parts.administrative_area_level_2,
            },
            {
                text: parts.administrative_area_level_3,
            },
            {
                text: parts.country,
            },
            {
                text: parts.locality,
            },
        ];
        var translatedContent = await translateContent(translateArray, "en");
        var listOfTranslatedArr = translatedContent.response.results;

        var responseName = await getAndSetTranslateVal(listOfTranslatedArr, 0, name);
        locationName = responseName;

        var tempStreet = "";
        var tempRoute = "";
        var tempSubLev1 = "";
        var tempSubLev2 = "";
        var tempSubLev3 = "";
        var adminAreaLev1 = "";
        var adminAreaLev2 = "";
        var adminAreaLev3 = "";
        var country,
            locality,
            postal = "";

        tempStreet = parts.street_number;
        tempRoute = await getAndSetTranslateVal( listOfTranslatedArr, 1, parts.route );
        tempSubLev1 = await getAndSetTranslateVal( listOfTranslatedArr, 2, parts.sublocality_level_1 );
        tempSubLev2 = await getAndSetTranslateVal( listOfTranslatedArr, 3, parts.sublocality_level_2 );
        tempSubLev3 = await getAndSetTranslateVal( listOfTranslatedArr, 4, parts.sublocality_level_3 );
        adminAreaLev1 = await getAndSetTranslateVal( listOfTranslatedArr, 5, parts.administrative_area_level_1 );
        adminAreaLev2 = await getAndSetTranslateVal( listOfTranslatedArr, 6, parts.administrative_area_level_2 );
        adminAreaLev3 = await getAndSetTranslateVal( listOfTranslatedArr, 7, parts.administrative_area_level_3 );
        country = await getAndSetTranslateVal( listOfTranslatedArr, 8, parts.country );  
            
       country = checkAndChangeContent(country, commonConstant.USA);

        locality = await getAndSetTranslateVal( listOfTranslatedArr, 9, parts.locality );
        postal = parts.postal_code;

        var tempAddress = [
            tempStreet,
            tempRoute,
            tempSubLev3,
            tempSubLev2,
            tempSubLev1,
        ]
            .filter(Boolean)
            .join(", ");

        var tempState = "";
        if (adminAreaLev1 === "Quebec") {
            tempState = "Québec";
        } else {
            tempState = adminAreaLev1 || "";
        }
         localStorage.setItem("countryname", country);
         localStorage.setItem("cityname", locality);
         localStorage.setItem("statename", tempState);
         localStorage.setItem("provincename", adminAreaLev2);
        locationMeta = {
            address: tempAddress,
            latitude: lat,
            longitude: lng,
            enteredLocationName: locationName,
            // From Google Maps
            country: country || "",
            state: tempState,
            province: adminAreaLev2 || "",
            city: locality || adminAreaLev3 || adminAreaLev2 || "",
            zip: postal || "",
        };

        actions.setTriageRequest({ location, locationMeta });
    } else {
        locationMeta = state.triageRequest.locationMeta;
    }

    const { sessionId, emergency } = state.triageRequest;
    const encounterToken = localStorage.getItem("token");
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const data = {
        identifier: sessionId,
        isEmergency: emergency,
        token: encounterToken,
        jwtAccessToken : jwtAccess_Token,
        accessToken : access_Token,
        ...locationMeta,
    };
    var response = await actions.sendTriageRequest({
        action: "submitLocation",
        data,
    });
    if (!state.isTravelAid2){
        var answers = response.data.answers;
        var locationRiskfactors = JSON.parse(answers).filter(
            (locationRiskfactor) =>
                locationRiskfactor.SymptomTypeId == symptomTypes.LocationRiskFactor
        )[0];
        state.triageRequest.locationRiskfactors = [];
        if (locationRiskfactors != undefined) {
            locationRiskfactors.PresentAnswers.forEach((presentAnswer) => {
                var s1 = presentAnswer;
                state.triageRequest.locationRiskfactors.push(s1);
            });
        }
    }
}
